import type React from "react";

export function TableSortIcon({ sorted, desc }: { sorted?: boolean; desc?: boolean }): React.ReactNode {
  return (
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
      <path
        d="M1.69734 4L4.5 0.763763L7.30266 4H1.69734Z"
        stroke="currentColor"
        fill={sorted && desc ? "currentColor" : "none"}
      />
      <path
        d="M7.30266 8L4.5 11.2362L1.69734 8L7.30266 8Z"
        stroke="currentColor"
        fill={sorted && !desc ? "currentColor" : "none"}
      />
    </svg>
  );
}
